import { useLocation } from 'react-router-dom';

import { sharedAcrossSportsPage } from 'constants/routes';

export const useSharedAcrossSportsPage = () => {
  const location = useLocation();

  return sharedAcrossSportsPage(location.pathname);
};
